export function sortByStringProperty<T>(
  prop: (object: T) => string,
  compare = (a: string, b: string) => a.localeCompare(b),
) {
  return (a: T, b: T) => {
    const propA = prop(a);
    const propB = prop(b);
    return a && b && propA && propB ? compare(propA, propB) : 0;
  };
}
